/*
  BDEK "Style It" (sections/bdek-style-it.liquid)
  - Dots: clicking one highlights and focuses that piece's size menu.
  - Pre-order sizes: show "Selling fast / [piece] [size] sold out. Pre-order now. Ships in 1–2 weeks."
    under the pieces as soon as they are picked.
  Shared by sections/bdek-style-it.liquid and sections/bdek-wear-it-with.liquid (any [data-bdek-look]).
  - "Add the whole look": every piece needs a size (or Skip); adds all via /cart/add.js,
    pre-order lines get a "Pre-order: Ships in 1–2 weeks" note, then opens Impulse's cart drawer.
  - [data-bdek-look-add-one] buttons add just their own piece.
  - select[data-bdek-look-follow] follows the main product form's size ("bdek:variant-change").
*/
(function () {
  function setActive(look, id) {
    look.querySelectorAll('[data-bdek-look-dot]').forEach(function (dot) {
      dot.classList.toggle('is-active', dot.getAttribute('data-bdek-look-dot') === id);
    });
    look.querySelectorAll('[data-bdek-look-piece]').forEach(function (row) {
      row.classList.toggle('is-active', row.getAttribute('data-bdek-look-piece') === id);
    });
  }

  function selection(field) {
    // Returns { id, preorder, name, size } or null (nothing chosen) or 'skip'
    if (field.tagName === 'SELECT') {
      if (!field.value) return null;
      if (field.value === 'skip') return 'skip';
      var option = field.options[field.selectedIndex];
      return {
        id: field.value,
        preorder: option.getAttribute('data-preorder'),
        name: field.getAttribute('data-piece-name'),
        size: option.getAttribute('data-size')
      };
    }
    return {
      id: field.value,
      preorder: field.getAttribute('data-preorder'),
      name: field.getAttribute('data-piece-name'),
      size: ''
    };
  }

  function updatePreorder(look) {
    var box = look.querySelector('[data-bdek-look-preorder]');
    var list = look.querySelector('[data-bdek-look-preorder-list]');
    if (!box || !list) return;
    var message = list.getAttribute('data-message') || 'sold out. Pre-order now.';
    list.innerHTML = '';
    look.querySelectorAll('[data-bdek-look-variant]').forEach(function (field) {
      var picked = selection(field);
      if (!picked || picked === 'skip' || !picked.preorder) return;
      var li = document.createElement('li');
      li.textContent = picked.name + (picked.size ? ' ' + picked.size : '') + ' ' + message + ' ' + picked.preorder + '.';
      list.appendChild(li);
    });
    box.hidden = list.children.length === 0;
  }

  function init(look) {
    if (look.dataset.bdekLookReady) return;
    look.dataset.bdekLookReady = 'true';

    look.querySelectorAll('[data-bdek-look-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var id = dot.getAttribute('data-bdek-look-dot');
        setActive(look, id);
        var row = look.querySelector('[data-bdek-look-piece="' + id + '"]');
        var field = row && (row.querySelector('select') || row.querySelector('a'));
        if (field) field.focus({ preventScroll: false });
      });
    });

    look.querySelectorAll('[data-bdek-look-piece]').forEach(function (row) {
      var id = row.getAttribute('data-bdek-look-piece');
      row.addEventListener('mouseenter', function () { setActive(look, id); });
      row.addEventListener('focusin', function () { setActive(look, id); });
    });

    look.addEventListener('change', function (event) {
      if (event.target.matches('[data-bdek-look-variant]')) {
        event.target.removeAttribute('aria-invalid');
        var row = event.target.closest('[data-bdek-look-piece]');
        var addOne = row && row.querySelector('[data-bdek-look-add-one].is-added');
        if (addOne) {
          addOne.textContent = addOne.getAttribute('data-label');
          addOne.classList.remove('is-added');
          if (addOne.getAttribute('data-aria')) addOne.setAttribute('aria-label', addOne.getAttribute('data-aria'));
        }
        updatePreorder(look);
      }
    });

    var form = look.querySelector('[data-bdek-look-form]');
    var status = look.querySelector('[data-bdek-look-status]');

    function addFields(fields, button) {
      var items = [];
      var missing = null;
      var preorderLabel = status.getAttribute('data-preorder-label') || 'Pre-order';

      fields.forEach(function (field) {
        var picked = selection(field);
        if (picked === null) {
          field.setAttribute('aria-invalid', 'true');
          if (!missing) missing = field;
          return;
        }
        if (picked === 'skip') return;
        var item = { id: Number(picked.id), quantity: 1 };
        if (picked.preorder) {
          item.properties = {};
          item.properties[preorderLabel] = picked.preorder;
        }
        items.push(item);
      });

      if (missing) {
        status.textContent = status.getAttribute(fields.length > 1 ? 'data-missing' : 'data-missing-one') || status.getAttribute('data-missing');
        missing.focus();
        return;
      }
      if (!items.length) return;

      button.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
            return data;
          });
        })
        .then(function (data) {
          status.textContent = status.getAttribute(fields.length > 1 ? 'data-added' : 'data-added-one') || status.getAttribute('data-added');
          // A piece added on its own is left out of "Add the whole look" (menu set to Skip)
          if (button.hasAttribute('data-bdek-look-add-one') && fields[0].tagName === 'SELECT') {
            fields[0].value = 'skip';
            button.setAttribute('data-label', button.getAttribute('data-label') || button.textContent);
            button.textContent = button.getAttribute('data-added-label') || 'Added';
            button.classList.add('is-added');
            button.setAttribute('data-aria', button.getAttribute('data-aria') || button.getAttribute('aria-label') || '');
            button.setAttribute('aria-label', button.textContent + ': ' + (fields[0].getAttribute('data-piece-name') || ''));
            updatePreorder(look);
          }
          var eventId = form.querySelector('[data-bdek-look-event-id]');
          if (eventId) eventId.value = items[0].id;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
        })
        .catch(function (error) {
          status.textContent = error.message;
        })
        .finally(function () {
          button.disabled = false;
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      addFields(Array.prototype.slice.call(look.querySelectorAll('[data-bdek-look-variant]')), form.querySelector('[type="submit"]'));
    });

    // "Add" on a single piece (Wear it with)
    look.addEventListener('click', function (event) {
      var one = event.target.closest('[data-bdek-look-add-one]');
      if (!one) return;
      var row = one.closest('[data-bdek-look-piece]');
      var field = row && row.querySelector('[data-bdek-look-variant]');
      if (field) addFields([field], one);
    });

    // Product page: the "this piece" menu follows the size picked in the main form
    document.addEventListener('bdek:variant-change', function (event) {
      var id = event.detail && event.detail.variantId;
      look.querySelectorAll('select[data-bdek-look-follow]').forEach(function (select) {
        var option = id && select.querySelector('option[value="' + id + '"]');
        if (option && !option.disabled) {
          select.value = String(id);
          select.removeAttribute('aria-invalid');
        }
      });
      updatePreorder(look);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bdek-look]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init when the section is added or changed
  document.addEventListener('shopify:section:load', initAll);
})();
